




































import { mapGetters, mapActions } from 'vuex'
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation } from '../store-helper'
import { IExam } from '../../../types'
import Comparison from '../lib/comparison'
import { qEditorState } from '../stores'

@Component({})
export default class ComparisonComponent extends Vue {
  get exam() {
    return qEditorState.exam
  }
  get comparison() {
    return qEditorState.comparison
  }

  public get dialog(): boolean {
    return false
  }

  @Watch('comparison')
  watchComparison() {
    if (this.comparison) {
      this.onSave()
    }
  }
  get questionComparisons() {
    return this.comparison ? this.comparison.questionComparisons.filter((item) => !item.isSame) : []
  }

  onCancel() {
    qEditorState.comparison = null
  }

  onSave() {
    qEditorState.submitSave()
  }
}
